import { render, staticRenderFns } from "./reducoesacrescimos.vue?vue&type=template&id=0ced511b"
import script from "./reducoesacrescimos.vue?vue&type=script&lang=js"
export * from "./reducoesacrescimos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports